import { useState } from "react";
import { Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";

function ComponentReportG2({data}){
    const [cShow, setCSHow] = useState(5)
    return (
        <Table bordered size="sm">
            <thead>
                <tr>
                    <th>Descripción</th>
                    <th># de citas disponibles</th>
                    <th>Cantidad de doctores</th>
                    <th>Online / Offline</th>
                </tr>
            </thead>
            <tbody>
                {
                    data.map((item,i)=>(
                        i < cShow &&
                        <tr key={i}>
                            <td>{item.name}</td>
                            <td>{item.citas}</td>
                            <td>
                                {item.type !== "DOCTOR" && <div>{item.count.countOnline}</div>}
                                {item.type !== "DOCTOR" && <div>{item.count.countOffline}</div>}
                            </td>
                            <td>
                                {
                                    item.type !== "DOCTOR" ? <div>Online</div> :
                                    item.count.countOnline > 0 && 
                                    <div>Online</div>
                                }
                                {
                                    item.type !== "DOCTOR" ? <div>Offline</div> :
                                    item.count.countOffline > 0 && 
                                    <div>Offline</div>
                                }
                            </td>
                        </tr>
                    ))
                }
            </tbody>
            {data.length > cShow ? 
                <tfoot>
                    <tr>
                        <td colSpan="4" className="text-right">
                            <span className="badge badge-primary cursor-pointer" onClick={e=>setCSHow(cShow+5)}>Ver más</span>
                        </td>
                    </tr>
                </tfoot> :
                data.length > 5 &&
                <tfoot>
                    <tr>
                        <td colSpan="4" className="text-right">
                            <span className="badge badge-primary cursor-pointer" onClick={e=>setCSHow(5)}>Ver menos</span>
                        </td>
                    </tr>
                </tfoot>
            }
        </Table>
    )
}

export default withTranslation()(ComponentReportG2)